import { render, staticRenderFns } from "./PacientesDetallePlanesTratamiento.vue?vue&type=template&id=284f3c2f&scoped=true"
import script from "./PacientesDetallePlanesTratamiento.vue?vue&type=script&lang=js"
export * from "./PacientesDetallePlanesTratamiento.vue?vue&type=script&lang=js"
import style0 from "./PacientesDetallePlanesTratamiento.vue?vue&type=style&index=0&id=284f3c2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284f3c2f",
  null
  
)

export default component.exports